{
  "features": {
    "config": {
      "title": "Companheiro do Cordeiro",
      "subtitle": "Configuração de integração com a Twitch",
      "sections": {
        "premiumSkins": {
          "title": "Skins Premium",
          "description": "Com essa extensão, seus espectadores podem aparecer como seguidores no jogo. Será possível personalizar seus avatares, incluindo o uso de Bits para skins premium. Selecione o valor em Bits que gostaria de cobrar por essas skins premium, ou deixe-as grátis para que todos possam usá-las.",
          "noBitsOption": "Não exigir Bits para skins premium",
          "bitsFeatureNotAvailable": "Não é possível usar Bits no seu canal. Seus espectadores poderão selecionar qualquer skin que quiserem sem usar Bits."
        }
      },
      "actions": {
        "save": "Salvar alterações"
      }
    },
    "followers": {
      "rafflePopup": {
        "title": "Participe do Culto de {{channelName}}!",
        "subtitle": "Você ganhou o sorteio!",
        "timeRemaining": "Tempo restante: {{time}}",
        "message": "Juntar-se a nós tem muitas vantagens: a chance de desenvolver membros demoníacos, a honra de dedicar cada segundo da sua vida ao Culto do Cordeiro e a glória de possivelmente ser sacrificado!",
        "viewerLinkCta": "Para entrar, por favor {share your identity}.",
        "actions": {
          "joinRaffle": "Quero entrar para o Culto",
          "joinRaffleViewerHasAlreadyJoined": "Você entrou no sorteio",
          "dismissRaffle": "Não, valeu",
          "dismissRaffleViewerHasAlreadyJoined": "Fechar"
        },
        "raffleJoinedMessage": "Seu interesse é apreciado. Você logo saberá se for a pessoa escolhida para entrar para o Culto. Já pode fechar essa janela."
      },
      "followerBuilder": {
        "title": "Crie seu seguidor",
        "steps": {
          "intro": {
            "message": "Você entrou para o Culto! O seguidor que você criar aqui aparecerá no jogo. Tenha em mente que seu seguidor morrerá em algum momento, mas ao menos será por uma boa causa.",
            "actions": {
              "goToNextStep": "Crie seu seguidor"
            }
          },
          "skinSelection": {
            "actions": {
              "goToNextStep": "Continuar"
            }
          },
          "colorSelection": {
            "actions": {
              "goToPreviousStep": "Voltar às skins",
              "goToNextStep": {
                "variationsForSkin": "Continuar",
                "noVariationsForSkin": "Criar meu seguidor"
              }
            }
          },
          "variationSelection": {
            "actions": {
              "goToPreviousStep": "Voltar às cores",
              "goToNextStep": "Criar meu seguidor"
            }
          }
        }
      }
    },
    "helpOrHinder": {
      "help": "ajudar",
      "hinder": "complicar",
      "hhVotingFlyout": {
        "title": "Ajudar ou Complicar",
        "message": "Vote",
        "timeRemaining": "Tempo restante: {{time}}",
        "voteCount": "{{amount}} votos"
      },
      "outcomeVotingFlyout": {
        "title": "Vote para {{helpOrHinder}} {{channelName}}",
        "timeRemaining": "Tempo restante: {{time}}"
      }
    }
  }
}
